module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.6e302b55.jpeg";